import { Button, Select, styled, useMediaQuery } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import classNames from 'classnames';
import React, { FormEvent, memo, useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useLocalStorage } from 'usehooks-ts';

import { Breadcrumbs, Input, Menu } from '../../components';
import { UpButton } from '../../components/Button/UpButton';
import { CatalogItems } from '../../components/Catalog/CatalogItems';
import { useActions } from '../../hooks/useActions';
import { useCatalog } from '../../hooks/useCatalog';
import { IMainCatalogItem } from '../../shared/types/main-catalog';

import './Catalog.sass';
import { getProcesses } from './utils';
import { IArticle } from '../../shared/types/articles';


export const Catalog = memo(() => {
  const { slug, catalogType } = useParams();
  const {
    setIsChange,
    setOffset,
    setPriceKopecksMax,
    setPriceKopecksMin,
    setPriceValue,
    setDescription,
    setPage,
    setProcesses,
    setTitle,
    setTitleTab,
    fetchCatalog,
  } = useActions();
  const {
    catalog,
    priceKopecksMax,
    priceKopecksMin,
    catalogItems,
    priceValue,
  } = useCatalog();

  //Доступен ли товар, либо, есть ли нужно количество
  const [openAlertNotAvailable, setOpenAlertNotAvailable] = useState(false);

  const [equipmentsMenuItems, setEquipmentsMenuItems] = useState<
    { type: 'h2' | 'li'; item: IMainCatalogItem }[]
  >([]);

  const [materialsMenuItems, setMaterialsMenuItems] = useState<
    { type: 'h2' | 'li'; item: IMainCatalogItem }[]
  >([]);

  //Максимальная ширина экрана. Возвращает - true
  const mobileScreen = useMediaQuery('(max-width:900px)');
  // Переключаем в сетку или с троку
  const [switchActive, setSwitchActive] = useLocalStorage(
    'SWITCH_IN_CATALOG',
    'grid'
  );
  //Вывод процессов
  const processesData = useMemo(() => {
    if (catalogType && catalog) {
      return getProcesses(catalogType, catalog);
    }
  }, [catalog, catalogType]);
  // ----- Functions ----- ///

  //Закрыть окно того, что нет доступное кол-во товара
  const handleCloseAlertNotAvailable = () => {
    setOpenAlertNotAvailable(false);
  };

  /*  const handlePriceChange = (event: Event, value: number | number[]) => {
    dispatch(setPriceValue(value as number[]));
  };

  const handleChangeMaxPrice = (e: FormEvent<HTMLInputElement>) => {
    dispatch(setPriceKopecksMax(+e.currentTarget.value * 100));
    dispatch(setPriceValue([priceValue[0], +e.currentTarget.value]));
  };

  const handleChangeMinPrice = (e: FormEvent<HTMLInputElement>) => {
    dispatch(setPriceKopecksMin(+e.currentTarget.value * 100));
    dispatch(setPriceValue([+e.currentTarget.value, priceValue[1]]));
  };*/

  // ----- useEffects ----- ///
  useEffect(() => {
    if (slug && catalogType) {
      const catalogT =
        catalogType === 'materials'
          ? 'material'
          : catalogType === 'equipments' || catalogType === 'equipment'
          ? 'equipment'
          : 'process';

      fetchCatalog({ slug, catalogType: catalogT });
    }
  }, [slug, catalogType]);

  useEffect(() => {
    if (processesData) {
      setProcesses(processesData);
    } else {
      setProcesses([]);
    }
    setPage('catalog');
  }, [processesData]);

  useEffect(() => {
    // @ts-ignore

    /*    if (catalog?.navigation?.length >= 2) {
      navigate(
        `/${catalog.navigation?.[0]?.slug}/${
          catalog.navigation?.[catalog.navigation.length - 2]?.slug
        }`
      );
    }*/

    if (catalog?.navigation?.[0]?.title === 'Процессы') {
      setTitle(catalog.navigation?.[catalog.navigation.length - 1]?.title);

      setDescription(
        `${
          catalog.navigation?.[catalog.navigation.length - 1]?.title
        } купить в интернет магазине Dazel.ru |Доставка и гарантия возврата! `
      );
      setTitleTab(
        `${
          catalog.navigation?.[catalog.navigation.length - 1]?.title
        } купить в интернет магазине Dazel.ru`
      );
    } else if (catalog?.navigation?.[0]?.title === 'Оборудование') {
      setTitle(
        catalog.processes_relation?.[catalog.processes_relation.length - 1]
          ?.title!
      );
      setDescription(
        `${catalog.equipment?.title} купить в интернет магазине Dazel.ru |Доставка и гарантия возврата! `
      );
      setTitleTab(
        `${catalog.equipment?.title} купить в интернет магазине Dazel.ru`
      );
    } else if (catalog?.navigation?.[0]?.title === 'Материалы') {
      setTitle(
        catalog.processes_relation?.[catalog.processes_relation.length - 1]
          ?.title!
      );
      setDescription(
        `${catalog.material?.title} купить в интернет магазине Dazel.ru |Доставка и гарантия возврата! `
      );
      setTitleTab(
        `${catalog.material?.title} купить в интернет магазине Dazel.ru`
      );
    } else {
      setTitle(null);
      setDescription('');
      setTitleTab('');
    }

    if (catalog?.material && catalog?.materials_relation) {
      // @ts-ignore
      setMaterialsMenuItems([
        // @ts-ignore
        ...catalog.material.children.map((child) => ({
          type: 'li',
          item: child,
        })),
        // @ts-ignore
        ...catalog.materials_relation.map((child) => ({
          type: 'li',
          item: child,
        })),
      ]);
    } else if (
      catalog?.materials_relation &&
      catalog.materials_relation?.[0]?.children
    ) {
      // @ts-ignore
      setMaterialsMenuItems([
        // @ts-ignore
        ...catalog.materials_relation?.[0]?.children.map((child) => ({
          type: 'li',
          item: child,
        })),
        // @ts-ignore
        ...catalog?.materials_relation
          ?.filter((item, index) => index > 0)
          .map((child) => ({
            type: 'li',
            item: child,
          })),
      ]);
    } else {
      setMaterialsMenuItems([]);
    }

    if (catalog?.equipment && catalog?.equipments_relation) {
      // @ts-ignore
      setEquipmentsMenuItems([
        // @ts-ignore
        ...catalog.equipment.children.map((child) => ({
          type: 'li',
          item: child,
        })),
        // @ts-ignore
        ...catalog.equipments_relation.map((child) => ({
          type: 'li',
          item: child,
        })),
      ]);
    } else if (
      catalog?.equipments_relation &&
      catalog.equipments_relation?.[0]?.children
    ) {
      // @ts-ignore
      setEquipmentsMenuItems([
        // @ts-ignore
        ...catalog.equipments_relation?.[0]?.children.map((child) => ({
          type: 'li',
          item: child,
        })),
        // @ts-ignore
        ...catalog?.equipments_relation
          ?.filter((item, index) => index > 0)
          .map((child) => ({
            type: 'li',
            item: child,
          })),
      ]);
    } else {
      setEquipmentsMenuItems([]);
    }
  }, [catalog, catalogItems]);

  useEffect(() => {
    if (priceValue[0] > 0) {
      setOffset(0);
      setIsChange(true);
    }
    setPriceKopecksMax(priceValue[1] * 100);
    setPriceKopecksMin(priceValue[0] * 100);
  }, [priceValue]);

  //Возвращает узел статьи 1го или 2го узла
  const getArticleNode = (node: IMainCatalogItem | undefined, nodes_relation: IMainCatalogItem[] | undefined): IArticle | null => {
    let retVal: IArticle | null = null;
    if(node){
      retVal = node.article;
    }else if(nodes_relation && nodes_relation.length > 0){
      retVal = nodes_relation[0].article;
    }
    return retVal;
  }

  return (
    <div className="catalog-page">
      <div
        className={classNames('catalog-page__wrapper', switchActive, {
          mobile: mobileScreen,
        })}
      >
        <Breadcrumbs navigation={catalog?.navigation} />
        {!mobileScreen && catalog?.navigation?.[0]?.title !== 'Процессы' && (
          <h1 className="catalog-page__title">
            {catalog?.navigation?.[catalog.navigation.length - 1]?.title}
          </h1>
        )}
        {mobileScreen && (
          <h1
            className={classNames('catalog-page__title mobile', switchActive)}
          >
            {catalog?.navigation?.[catalog.navigation.length - 1]?.title}
          </h1>
        )}
        <div
          className={classNames('catalog-page__content', switchActive, {
            mobile: mobileScreen,
          })}
        >
          <div
            className={classNames('catalog-page__left', {
              mobile: mobileScreen,
            })}
          >
            <Menu
              catalogType="materials"
              placement="right-start"
              title={
                catalog?.material?.title ||
                catalog?.materials_relation?.[0]?.title ||
                'Материалы'
              }
              article={getArticleNode(catalog?.material, catalog?.materials_relation)}
              menuItems={materialsMenuItems}
              className={classNames('catalog-page__menu', switchActive, {
                mobile: mobileScreen,
              })}
            />

            {/*<div className={classNames('catalog-page-price', switchActive)}>
              <h2>Цена</h2>
              <Slider min={0} max={300000} size="small" value={priceValue} onChange={handlePriceChange} />
              <div className="catalog-page-price__inputs">
                <Input variant="outlined" value={priceValue[0]} onChange={handleChangeMinPrice} />
                <Input variant="outlined" value={priceValue[1]} onChange={handleChangeMaxPrice} />
              </div>
            </div>*/}
          </div>
          <CatalogItems
            type="catalog"
            items={catalogItems}
            button={true}
            priceKopecksMax={priceKopecksMax}
            priceKopecksMin={priceKopecksMin}
          />

          <Menu
            catalogType="equipment"
            placement="left-start"
            title={
              catalog?.equipment?.title ||
              catalog?.equipments_relation?.[0]?.title ||
              'Оборудование'
            }
            article={getArticleNode(catalog?.equipment, catalog?.equipments_relation)}
            menuItems={equipmentsMenuItems}
            className={classNames('catalog-page__menu', switchActive, {
              mobile: mobileScreen,
            })}
          />
        </div>
      </div>
      {/* Кнопка на вверх */}
      {!mobileScreen && <UpButton />}
      {openAlertNotAvailable && (
        <Dialog
          open={openAlertNotAvailable}
          onClose={handleCloseAlertNotAvailable}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {'Данный товар не доступен или нет желаемого кол-ва'}
          </DialogTitle>

          <DialogActions>
            <Button onClick={handleCloseAlertNotAvailable} autoFocus>
              ок
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </div>
  );
});
